import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-22">
      <motion.div initial={{
      scale: 0.95,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.95,
      opacity: 0
    }} onClick={e => e.stopPropagation()} className="bg-white text-charcoal rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" data-id="element-23">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-24">
          <h2 className="text-xl font-bold text-navy" data-id="element-25">{title}</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors" data-id="element-26">
            <X className="w-5 h-5" data-id="element-27" />
          </button>
        </div>
        <div className="px-6 py-6 text-sm leading-relaxed space-y-4" data-id="element-28">
          {children}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-charcoal text-white/60 py-12 px-4 text-center text-sm" data-id="element-29">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-30">
          <p data-id="element-31">
            © {new Date().getFullYear()} Emprender con Unción | Todos los
            derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-white/80" data-id="element-32">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-33">
              Política de Privacidad
            </button>
            <span data-id="element-34">|</span>
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-35">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-white/40 max-w-2xl mx-auto leading-relaxed pt-6 border-t border-white/10" data-id="element-36">
            "Este sitio no es parte de Facebook™ ni de Meta™. Además, este
            sitio no está respaldado por Facebook™ de ninguna manera.
            Facebook™ es una marca registrada de Meta™ Inc."
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-37">
        {showPrivacy && <Modal title="Política de Privacidad" onClose={() => setShowPrivacy(false)} data-id="element-38">
            <p data-id="element-39">
              <strong data-id="element-40">Última actualización:</strong> Marzo 2026
            </p>
            <p data-id="element-41">
              En Emprender con Unción ("nosotros", "nuestro"), respetamos tu
              privacidad y nos comprometemos a proteger tu información personal.
              Esta política describe cómo recopilamos, usamos y protegemos tus
              datos.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-42">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-43">
              Recopilamos la información que nos proporcionas directamente al
              realizar una compra, incluyendo: nombre, dirección de correo
              electrónico y datos de pago. Los pagos son procesados de forma
              segura a través de Shopify y no almacenamos información de
              tarjetas de crédito en nuestros servidores.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-44">
              2. Uso de la Información
            </h3>
            <p data-id="element-45">
              Utilizamos tu información para: procesar tu pedido y entregar los
              productos digitales adquiridos, enviarte comunicaciones
              relacionadas con tu compra, mejorar nuestros productos y
              servicios, y cumplir con obligaciones legales.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-46">
              3. Cookies y Tecnologías de Seguimiento
            </h3>
            <p data-id="element-47">
              Utilizamos el Pixel de Meta (Facebook) para medir la efectividad
              de nuestra publicidad. También podemos usar cookies para mejorar
              tu experiencia de navegación. Puedes desactivar las cookies en la
              configuración de tu navegador.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-48">
              4. Compartir Información
            </h3>
            <p data-id="element-49">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros, excepto cuando sea necesario para procesar tu pedido
              (procesadores de pago) o cuando la ley lo requiera.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-50">5. Seguridad</h3>
            <p data-id="element-51">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-52">
              6. Tus Derechos
            </h3>
            <p data-id="element-53">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. Para ejercer estos derechos, contáctanos a través de
              nuestros canales oficiales.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-54">
              7. Cambios a Esta Política
            </h3>
            <p data-id="element-55">
              Nos reservamos el derecho de actualizar esta política en cualquier
              momento. Los cambios serán publicados en esta página con la fecha
              de actualización correspondiente.
            </p>
          </Modal>}

        {showTerms && <Modal title="Términos y Condiciones" onClose={() => setShowTerms(false)} data-id="element-56">
            <p data-id="element-57">
              <strong data-id="element-58">Última actualización:</strong> Marzo 2026
            </p>
            <p data-id="element-59">
              Al acceder y utilizar este sitio web y adquirir nuestros
              productos, aceptas los siguientes términos y condiciones.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-60">
              1. Productos Digitales
            </h3>
            <p data-id="element-61">
              Todos los productos ofrecidos en este sitio son de naturaleza
              digital (ebooks, guías, plantillas). Al completar tu compra,
              recibirás acceso inmediato al contenido a través de un enlace de
              descarga enviado a tu correo electrónico.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-62">
              2. Garantía de Devolución
            </h3>
            <p data-id="element-63">
              Ofrecemos una garantía de satisfacción de 7 días. Si no estás
              satisfecho con tu compra, puedes solicitar un reembolso completo
              dentro de los 7 días posteriores a la fecha de compra. Para
              solicitar un reembolso, contáctanos a través de nuestros canales
              oficiales.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-64">
              3. Propiedad Intelectual
            </h3>
            <p data-id="element-65">
              Todo el contenido de este sitio y de los productos digitales,
              incluyendo textos, gráficos, logotipos y materiales descargables,
              es propiedad de Emprender con Unción y está protegido por las
              leyes de propiedad intelectual. Queda prohibida la reproducción,
              distribución o reventa del contenido sin autorización expresa.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-66">
              4. Uso del Producto
            </h3>
            <p data-id="element-67">
              Los productos adquiridos son para uso personal y educativo. No
              garantizamos resultados financieros específicos. El éxito depende
              de múltiples factores, incluyendo tu esfuerzo, dedicación y
              circunstancias individuales.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-68">
              5. Limitación de Responsabilidad
            </h3>
            <p data-id="element-69">
              Emprender con Unción proporciona información educativa y no
              constituye asesoría legal, financiera o fiscal. Recomendamos
              consultar con profesionales calificados para decisiones legales y
              financieras específicas.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-70">
              6. Modificaciones
            </h3>
            <p data-id="element-71">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Las modificaciones entrarán en vigor inmediatamente
              después de su publicación en este sitio.
            </p>

            <h3 className="font-bold text-navy text-base mt-4" data-id="element-72">
              7. Ley Aplicable
            </h3>
            <p data-id="element-73">
              Estos términos se rigen por las leyes de los Estados Unidos de
              América. Cualquier disputa será resuelta en los tribunales
              competentes de dicha jurisdicción.
            </p>
          </Modal>}
      </AnimatePresence>
    </>;
}